<template>
    <div v-if="currentUser" class="usefultips-container">
      <h2>Porady</h2>
    </div>
  </template>
  
  <script>
  import { useMeta } from 'vue-meta';
  import {useAuthStore} from "@/stores/auth";
  import {useAppStore} from "@/stores/app";
  export default{
    name:'UsefulTips',
    setup () {
      useMeta({title: 'Porady'})
    
    return {
        authStore: useAuthStore(),
        appStore: useAppStore(),
    }
  },
    data(){
      return{

      }
    },
    computed: {
        currentUser() {
            return this.authStore.user;
        }
      },
      mounted() {
        if (!this.currentUser) {
          this.$router.push('/login');
        }
        else if (this.currentUser.role_id !== 2) {
          this.$router.push('/login');
        }
        if(!this.appStore.isSubscribed){
          this.$router.push('/dla-biznesu/profile/user-data')
        }
      },
    props:{
  
    },
    methods:{

    }
  }
  </script>
  
  <style scoped lang='scss'>
  </style>